import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/deira-city-centre-1.webp';

const Project_one = () => {

  return (
    <>
    
          <div className='project_1_work' id="workBanner">
    
            <div className="container project_our_work">
    
              <div className="heading">
                <h1>Deira City Centre</h1>
              </div>
    
              <hr></hr>
              <div className='project_section'>
                <div className="project_section_content">
                  <h1 className="project_scope">Scope of Work</h1>
                  <p>One of Dubai's oldest and most established regional shopping malls, developed by Majid Al Futtaim. A landmark retail
                    destination since 1995, Deira City Centre underwent significant MEP upgrade and maintenance works to sustain operations
                    across its life cycle.</p>
                  <p>MAIN CONTRACTOR : -</p>
                  <p>MEP CONTRACTOR : ETA</p>
                  <p>GEMCO SCOPE OF WORKS : Various MEP works</p>
                  {/* <h2 className="project_years">2014 – 2022</h2> */}
                </div>
                <div className='project_1_card'>
                  <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                </div>
              </div>
            </div>
          </div>
    
        </>

  )
}

export default Project_one